import React, { Component } from 'react';

import { Col, Container, Row } from 'reactstrap';

import { DocumentTitle } from '@hsp/react-component-library';

import UserDashboard from '@p/security/users/dashboard/component/dashboard-body.component';
import UserTabs from '@p/security/users/dashboard/component/user-tabs/tabs.component';

import { t } from '@u/strings';

class DashBoardPage extends Component {
  render() {
    return (
      <React.Fragment>
        <DocumentTitle title={t('Site.Dashboard')} />
        <div className="page-content">
          <Container fluid>
            <Row className="mb-4">
              <Col
                md={6}
                sm={12}
                xl={7}>
                <h4>Client Groups</h4>
              </Col>
            </Row>
            <Row className="mb-4">
              <UserTabs />
            </Row>
            <Row className="mb-4">
              <UserDashboard />
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default DashBoardPage;
